import * as tslib_1 from "tslib";
import selectAfterMoveActionOption from '../actions/selectAfterMoveActionOption';
import selectLoadMessageOnSignOnOption from '../actions/selectLoadMessageOnSignOnOption';
import selectReadingPanePositionOption from '../actions/selectReadingPanePositionOption';
import store from '../store/store';
import { ChoiceGroupWithImages } from 'owa-choice-group-with-images';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var READING_PANE_RIGHT_SVG = require('./readingPaneRightLarge.svg');
var READING_PANE_OFF_SVG = require('./readingPaneOffLarge.svg');
var READING_PANE_BOTTOM_SVG = require('./readingPaneBottomLarge.svg');
var ReadingPaneFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneFull, _super);
    function ReadingPaneFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAfterMoveActionChange = function (ev, option) {
            selectAfterMoveActionOption(option.key);
        };
        _this.onChangeReadingPane = function (ev, option) {
            selectReadingPanePositionOption(parseInt(option.key, 10));
        };
        _this.onChangeLoadMessage = function (ev, option) {
            selectLoadMessageOnSignOnOption(option.key === 'true');
        };
        return _this;
    }
    ReadingPaneFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var readingPanePositionSelectedKey = "" + getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
        var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
        var showReadingPaneOnFirstLoadSelectedKey = "" + getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
        // Account for the case where RP is not 'Off', but we should 'ReturnToView' after move/delete
        // This is done in the view to preserve the underlying selection if a users switches RP position back and forth
        if (readingPanePositionSelectedKey !== "" + ReadingPanePosition.Off &&
            actionAfterMoveKey === 'ReturnToView') {
            actionAfterMoveKey = 'Next';
        }
        var options = [
            {
                key: "" + ReadingPanePosition.Right,
                text: strings.options_readingPane_positionRight,
                imageUri: READING_PANE_RIGHT_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition.Bottom,
                text: strings.options_readingPane_positionBottom,
                imageUri: READING_PANE_BOTTOM_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition.Off,
                text: strings.options_readingPane_positionHide,
                imageUri: READING_PANE_OFF_SVG,
                width: 280,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(ChoiceGroupWithImages, { selectedKey: readingPanePositionSelectedKey, label: strings.options_readingPane_positionLabel, options: options, onChange: this.onChangeReadingPane }),
            React.createElement(ChoiceGroup, { selectedKey: actionAfterMoveKey, label: strings.options_readingPane_afterMove_title, options: [
                    {
                        key: 'Next',
                        text: strings.options_readingPane_afterMove_next,
                    },
                    {
                        key: 'Previous',
                        text: strings.options_readingPane_afterMove_previous,
                    },
                    {
                        key: 'ReturnToView',
                        text: strings.options_readingPane_afterMove_returnToView,
                        disabled: readingPanePositionSelectedKey !== "" + ReadingPanePosition.Off,
                    },
                ], onChange: this.onAfterMoveActionChange }),
            React.createElement(ChoiceGroup, { selectedKey: showReadingPaneOnFirstLoadSelectedKey, label: strings.options_readingPane_actionOnLoadLabel, options: [
                    {
                        key: 'true',
                        text: strings.options_readingPane_actionOnLoadFirstItem,
                    },
                    {
                        key: 'false',
                        text: strings.options_readingPane_actionOnLoadNoAction,
                    },
                ], onChange: this.onChangeLoadMessage })));
    };
    ReadingPaneFull = tslib_1.__decorate([
        reactive({
            userOptions: function () { return getUserConfiguration().UserOptions; },
            optionState: function () { return store; },
        })
    ], ReadingPaneFull);
    return ReadingPaneFull;
}(React.Component));
export default ReadingPaneFull;
//# sourceMappingURL=ReadingPaneFull.js.map